/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DocumentInfo from './DocumentInfo';

/**
 * The CompanyInfoDocuments model module.
 * @module model/CompanyInfoDocuments
 * @version 1.0.0
 */
class CompanyInfoDocuments {
    /**
     * Constructs a new <code>CompanyInfoDocuments</code>.
     * @alias module:model/CompanyInfoDocuments
     */
    constructor() { 
        
        CompanyInfoDocuments.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompanyInfoDocuments</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompanyInfoDocuments} obj Optional instance to populate.
     * @return {module:model/CompanyInfoDocuments} The populated <code>CompanyInfoDocuments</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyInfoDocuments();

            if (data.hasOwnProperty('company_details')) {
                obj['company_details'] = DocumentInfo.constructFromObject(data['company_details']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/DocumentInfo} company_details
 */
CompanyInfoDocuments.prototype['company_details'] = undefined;






export default CompanyInfoDocuments;

